import { useQuery } from "@tanstack/react-query";
import { getUploadedPapers, Paper } from "helpers/api";
import { PAPER_UPLOADING_KEY } from "./useResearchPaperUpload";
import { useAllUploadingFiles } from "./useAllUploadingFiles";

const FAKE_UPLOADING_PAPER: Paper = {
  paper_id: "",
  title: "",
  authors: [],
  badges: {},
  citation_count: 0,
  display_text: "",
  doc_id: "",
  doi: "",
  has_valid_chat_pdf: false,
  journal: "",
  pages: "",
  primary_author: "",
  url_slug: "",
  volume: "",
  year: new Date().getFullYear(),
};

export const useUploadedPapers = () => {
  const query = useQuery(
    ["uploaded-papers"],
    async () => {
      const response = await getUploadedPapers();
      return response.papers;
    },
    {
      refetchInterval: 5000,
      staleTime: 0,
    }
  );

  const isUploadingQuery = useQuery([PAPER_UPLOADING_KEY], () => 0, {
    initialData: 0,
    staleTime: Infinity,
  });
  const uploadCount = isUploadingQuery.data as number;

  // Get all uploading files
  const uploadingFiles = useAllUploadingFiles();

  const basePapers = query.data ?? [];
  const isLoadingPaper = query.data?.some((paper) => !paper.title);

  // Create fake uploading papers for each uploading file
  const fakeUploadingPapers: Paper[] = uploadingFiles.map((fileInfo) => ({
    ...FAKE_UPLOADING_PAPER,
    title: `Uploading: ${fileInfo.filename}`,
  }));

  // Add fake uploading papers if there are uploads in progress and no loading papers
  const papers =
    uploadCount > 0 && !isLoadingPaper
      ? [...fakeUploadingPapers, ...basePapers]
      : basePapers;

  return {
    papers: papers,
    isLoadingPaper: isLoadingPaper || uploadCount > 0,
    isLoading: query.isLoading,
  };
};

export default useUploadedPapers;
